import React from 'react';
import { alertRef } from '../../App';
import { Button } from '../../Components/StyledComponents';
import { convertCost } from '../../Utils/functions';
import './CouponInfo.scss';

const couponVariant = {
    '상품증정' : '#d8ead3',
    '% 할인' : '#ffe6b4',
    '1+1' : '#cce0ff',
    '원 할인' : '#ffddda'
}

const couponTextVariant = {
    '상품증정' : '#3d9822',
    '% 할인' : '#ffaa00',
    '1+1' : '#0064ff',
    '원 할인' : '#f95f53'
}

const CouponInfo = ({info, deleteCoupon, closeModal }) => {
    return (
        <div className='coupon-info'>
            <div className='row between'>
                <div className='type-box' style={{ backgroundColor : couponVariant[info.Type], color : couponTextVariant[info.Type]}}>
                    %할인
                </div>
                <img src={require('../../aseets/icons/close.svg').default} style={{ width : 31, height : 31 }} onClick={() => closeModal()}/>
            </div>
            <p className='coupon-title'>{info.Name}</p>
            <div className='info-box'>
                <p className='coupon-info-text'>{info.Description}</p>
            </div>
            <div className='row'>
                <p className='info-text'>유효기간 : {info.ExpiryPeriod}일</p>
                <p className='info-text'>발행수 : {convertCost(info.IssuedCount)}</p>
                <p className='info-text'>사용수 : {convertCost(info.UsedCount)}</p>
                <p className='info-text' style={{marginRight : 0}}>반응률 : {(info.UsedCount/info.IssuedCount * 100).toFixed(2) === 'NaN' ? '0.00'  : (info.UsedCount/info.IssuedCount * 100).toFixed(2) }%</p>
            </div>
            {
                info.IssuedCount === 0 &&
                <div className='btn-row'>
                    <Button
                        variant="gray"
                        fontSize={16}
                        style={{ width : 118, alignSelf: 'flex-end' }}
                        onClick={() => alertRef.current.showAlert({ title : `정말 쿠폰을 삭제하시겠어요?`, isConfirm : true, confirmText : '삭제', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();deleteCoupon(info._id.$oid)} })}
                    >
                        쿠폰 삭제
                    </Button>
                </div>
            }
        </div>
    )
}

export default CouponInfo;